// Firebase Auth error codes -> messages people can act on (instead of
// "Firebase: Error (auth/wrong-password).")
const MESSAGES = {
  "auth/invalid-email": "That email address doesn't look right. Please check it.",
  "auth/missing-email": "Please enter your email address.",
  "auth/user-not-found": "Wrong email or password. Please try again.",
  "auth/wrong-password": "Wrong email or password. Please try again.",
  "auth/invalid-credential": "Wrong email or password. Please try again.",
  "auth/invalid-login-credentials": "Wrong email or password. Please try again.",
  "auth/user-disabled": "This account has been deactivated. Please contact support@guiders.pt.",
  "auth/too-many-requests": "Too many attempts. Please wait a few minutes, or reset your password.",
  "auth/network-request-failed": "No connection. Check your internet and try again.",
  "auth/email-already-in-use": "There's already an account with this email. Log in instead, or reset your password.",
  "auth/weak-password": "Please choose a stronger password (at least 8 characters).",
  "auth/popup-closed-by-user": "The Google window was closed before signing in. Please try again.",
  "auth/cancelled-popup-request": "The Google window was closed before signing in. Please try again.",
  "auth/popup-blocked": "Your browser blocked the Google window. Allow pop-ups for guiders.pt and try again.",
  "auth/account-exists-with-different-credential":
    "This email is already used with another sign-in method. Log in with your email and password.",
  "auth/operation-not-allowed": "This sign-in method isn't available right now. Please use your email and password.",
  "auth/unauthorized-domain": "This sign-in method isn't available on this website address.",
  "auth/expired-action-code": "This link has expired. Please ask for a new one.",
  "auth/invalid-action-code": "This link is no longer valid. It may have been used already. Please ask for a new one.",
  "auth/requires-recent-login": "For your security, please log in again and then retry.",
};

export function authErrorMessage(error) {
  const code = error && error.code;
  if (code && MESSAGES[code]) return MESSAGES[code];
  return "Something went wrong. Please try again, or contact support@guiders.pt.";
}
